import axios from 'axios';

async function ObtenerBanner(prmBanner: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_banners"
    
    const datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "id_banner": prmBanner}
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerBanner;